import { createRequestTypes } from 'appUtils';

export const FETCH_PROFIT_REPORT = createRequestTypes('FETCH_PROFIT_REPORT');
export const SET_PROFIT_REPORT_IS_FETCHING_PHASES =
  'SET_PROFIT_REPORT_IS_FETCHING_PHASES';
export const SET_PROFIT_REPORT_IS_FETCHING_PROJECTS =
  'SET_PROFIT_REPORT_IS_FETCHING_PROJECTS';
